module.exports = __webpack_public_path__ + "img/6.c4a38857.jpg";